window.customElements.define('modemmate-services', class extends HTMLElement {

  productForm = undefined;
  assemblyChecked = false;
  assemblyServiceId = undefined;
  STORAGE_PREFIX = 'assembly_service_';
  DEFAULT_SHIPPING_ZIP = '10001';
  ZIP_OUT_OF_AREA_MSG = "We're sorry! Our assembly team hasn't reached your area yet. We're working hard to expand our coverage.";

  getServiceSelection(service) {
    if (!service) return null;
    return {
      variantId: service.getAttribute('data-service-id'),
      providerCode: service.getAttribute('data-service-provider-code') || '',
      providerName: service.getAttribute('data-service-provider') || '',
      offeringCode: service.getAttribute('data-service-offering-code') || '',
      offeringName: service.getAttribute('data-service-offering-name') || '',
      offeringId: service.getAttribute('data-service-offering-id') || '',
    };
  }

  persistSelection(relatedId, selection) {
    if (!relatedId || !selection?.variantId) return;
    window.sessionStorage.setItem(this.STORAGE_PREFIX + relatedId, JSON.stringify(selection));
  }

  constructor() {
    super();
    this.services = this.querySelectorAll('.product-services__item');
    this.variantId = this.getAttribute('data-variant-id');
    this.zeroPriceService = Array.from(this.services).find(service => {
      const price = Number(service.getAttribute('data-service-price'));
      return price === 0 && !this.hasZipcodeList(service);
    });
    this.initShippingDelivery();

    // 默认去掉当前变体缓存
    if (this.variantId) {
      window.sessionStorage.removeItem(this.STORAGE_PREFIX + this.variantId);
    }

    // 默认仅选择价格为 0 的服务，若不存在则不默认选中任何项
    if (this.zeroPriceService) {
      this.selectService(this.zeroPriceService, this.variantId);
    }

    this.services.forEach(service => {
      const radio = service.querySelector('.product-services__icon');
      const detailsLink = service.querySelector('.product-services__details-link');

      // 处理详情链接点击事件
      if (detailsLink) {
        detailsLink.addEventListener('click', (e) => {
          e.stopPropagation(); // 阻止事件冒泡，避免触发服务选择
          const serviceId = detailsLink.getAttribute('data-service-id');
          const detailsDiv = service.querySelector(`.product-services__details[data-service-id="${serviceId}"]`);
          if (detailsDiv) {
            const content = detailsDiv.innerHTML;
            this.openDetailsModal(content);
          }
        });
      }

      service.addEventListener('click', () => {
        const params = new URLSearchParams(window.location.search);
        const relatedId = params.get('variant') || this.variantId;

        // 当前 service 的配置信息
        const selection = this.getServiceSelection(service);

        const isAlreadyChecked = radio && radio.checked;

        if (isAlreadyChecked) {
          // 当前项已选中：若存在 0 价服务，则强制保持 0 价服务为选中；否则允许取消
          if (this.zeroPriceService) {
            this.selectService(this.zeroPriceService, relatedId);
          } else {
            this.clearSelection(relatedId);
          }
        } else if (this.hasZipcodeList(service) && this.activeZip) {
          this.selectService(service, relatedId, selection);
        } else if (this.hasZipcodeList(service)) {
          this.showShippingZipError('Enter a ZIP code to view available assembly services.');
        } else {
          // 选中当前项并写入缓存
          this.selectService(service, relatedId, selection);
        }
      });
    });
  }

  clearServiceSelectionUI() {
    this.services.forEach(s => {
      const r = s.querySelector('.product-services__icon');
      if (r) {
        r.checked = false;
      }
      s.classList.remove('product-services__item--selected');
    });
  }

  selectService(service, relatedId, selection) {
    this.clearServiceSelectionUI();

    const radio = service ? service.querySelector('.product-services__icon') : null;
    const resolvedSelection = selection || this.getServiceSelection(service);

    if (radio) {
      radio.checked = true;
    }
    if (service) {
      service.classList.add('product-services__item--selected');
    }

    this.assemblyChecked = !!resolvedSelection?.variantId;
    this.assemblyServiceId = resolvedSelection?.variantId;
    this.assemblySelection = resolvedSelection;
    this.persistSelection(relatedId, resolvedSelection);
  }

  clearSelection(relatedId) {
    this.clearServiceSelectionUI();
    this.assemblyChecked = false;
    this.assemblyServiceId = undefined;
    this.assemblySelection = undefined;
    window.sessionStorage.removeItem(this.STORAGE_PREFIX + relatedId);
  }


  updateRelatedServiceInfo(variantId) {
    this.productForm = document.querySelector('product-form');

    if (this.assemblyChecked && this.assemblySelection) {
      this.persistSelection(variantId, this.assemblySelection);
    } else {
      window.sessionStorage.removeItem(this.STORAGE_PREFIX + variantId);
    }
  }

  openDetailsModal(content) {
    const drawer = document.querySelector('product-services-details-drawer');
    const contentDiv = drawer ? drawer.querySelector('.product-services-details-drawer__content') : null;

    if (!drawer || !contentDiv) return;

    // 设置内容（直接使用 innerHTML，因为内容可能包含 HTML）
    contentDiv.innerHTML = content;

    // 打开 drawer
    drawer.open();
  }

  /** 解析 data-zipcode-list 为邮编数组 */
  parseZipcodeList(raw) {
    if (!raw || !String(raw).trim()) return null;

    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed) || parsed.length === 0) return null;
      return parsed.map((zip) => String(zip).trim());
    } catch (e) {
      return null;
    }
  }

  /** 是否配置了邮编白名单 */
  hasZipcodeList(service) {
    return this.parseZipcodeList(service.getAttribute('data-zipcode-list')) !== null;
  }

  initShippingDelivery() {
    const root = this.closest('.product-services');
    this.shippingDelivery = root ? root.querySelector('[data-services-shipping]') : null;
    if (!this.shippingDelivery) return;

    this.shippingZipTrigger = this.shippingDelivery.querySelector('[data-services-zip-trigger]');
    this.shippingZipLabel = this.shippingDelivery.querySelector('[data-services-zip-label]');
    this.shippingZipForm = this.shippingDelivery.querySelector('[data-services-zip-form]');
    this.shippingZipInput = this.shippingDelivery.querySelector('[data-services-zip-input]');
    this.shippingZipUpdate = this.shippingDelivery.querySelector('[data-services-zip-update]');
    this.shippingZipError = this.shippingDelivery.querySelector('[data-services-zip-error]');
    const savedZip = this.getSavedShippingZip();
    this.activeZip = savedZip || this.DEFAULT_SHIPPING_ZIP;

    this.shippingZipTrigger?.addEventListener('click', () => this.toggleShippingZipForm());
    this.shippingZipInput?.addEventListener('input', () => {
      const zip = this.normalizeZip(this.shippingZipInput.value);
      this.shippingZipInput.value = zip;
      this.shippingZipUpdate.disabled = zip.length !== 5;
      this.hideShippingZipError();
    });
    this.shippingZipUpdate?.addEventListener('click', () => this.updateShippingZip());

    this.applyShippingZip(this.activeZip);

    // A manually selected ZIP always wins. GeoIP only supplies the first default.
    if (!savedZip) this.loadDefaultZipByIP();
  }

  async loadDefaultZipByIP() {
    try {
      const response = await fetch('https://ipapi.co/json/', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const location = await response.json();
      if (location.country_code !== 'US') return;

      const zip = this.normalizeZip(location.postal);
      if (!zip) return;

      this.saveShippingZip(zip);
      this.applyShippingZip(zip);
    } catch (error) {
      // GeoIP is only a convenience default; keep the fallback ZIP on failure.
    }
  }

  getSavedShippingZip() {
    try {
      return this.normalizeZip(window.localStorage.getItem('assembly_service_zip'));
    } catch (error) {
      return '';
    }
  }

  saveShippingZip(zip) {
    try {
      window.localStorage.setItem('assembly_service_zip', zip);
    } catch (error) {
      // Keep ZIP selection working when browser storage is unavailable.
    }
  }

  applyShippingZip(zip) {
    this.activeZip = zip;
    if (this.shippingZipLabel) this.shippingZipLabel.textContent = zip;
    this.hideShippingZipError();
    this.filterServicesByZip(zip);
  }

  toggleShippingZipForm() {
    if (!this.shippingZipForm || !this.shippingZipInput) return;

    this.shippingZipForm.hidden = !this.shippingZipForm.hidden;
    this.hideShippingZipError();
    if (!this.shippingZipForm.hidden) {
      this.shippingZipInput.value = this.activeZip;
      this.shippingZipUpdate.disabled = this.normalizeZip(this.shippingZipInput.value).length !== 5;
      this.shippingZipInput.focus();
    }
  }

  updateShippingZip() {
    const zip = this.normalizeZip(this.shippingZipInput?.value);
    if (zip.length !== 5) {
      this.showShippingZipError('Please enter a valid 5 digit US zip code.');
      return;
    }

    this.saveShippingZip(zip);
    this.applyShippingZip(zip);
  }

  filterServicesByZip(zip) {
    const eligibleServices = Array.from(this.services).filter((service) => {
      const zipList = this.parseZipcodeList(service.getAttribute('data-zipcode-list'));
      return !zipList || this.isZipInList(zip, zipList);
    });
    const serviceGroups = new Map();
    eligibleServices.forEach((service) => {
      const providerCode = service.getAttribute('data-service-provider-code') || service.getAttribute('data-service-provider') || '';
      const offeringCode = service.getAttribute('data-service-offering-code') || service.getAttribute('data-service-offering-name') || '';
      // Missing provider/type data must not make unrelated services compete with one another.
      const groupKey = providerCode && offeringCode
        ? `${providerCode}::${offeringCode}`
        : `service::${service.getAttribute('data-service-id')}`;
      const group = serviceGroups.get(groupKey) || [];
      group.push(service);
      serviceGroups.set(groupKey, group);
    });

    const visibleServices = new Set();
    serviceGroups.forEach((services) => {
      const lowestPrice = Math.min(
        ...services.map((service) => Number(service.getAttribute('data-service-price')))
      );
      const lowestPriceService = services.find(
        (service) => Number(service.getAttribute('data-service-price')) === lowestPrice
      );
      if (lowestPriceService) visibleServices.add(lowestPriceService);
    });

    this.services.forEach((service) => {
      service.hidden = !visibleServices.has(service);
    });
    this.querySelector('.product-services__list')?.classList.remove('product-services__list--pending');

    const selectedService = Array.from(this.services).find((service) => {
      const radio = service.querySelector('.product-services__icon');
      return radio && radio.checked;
    });
    if (selectedService && !visibleServices.has(selectedService)) {
      const params = new URLSearchParams(window.location.search);
      this.clearSelection(params.get('variant') || this.variantId);
    }

    if (!visibleServices.size) {
      this.showShippingZipError(this.ZIP_OUT_OF_AREA_MSG);
    }
  }

  showShippingZipError(message) {
    if (!this.shippingZipError) return;
    this.shippingZipError.textContent = message;
    this.shippingZipError.hidden = false;
  }

  hideShippingZipError() {
    if (!this.shippingZipError) return;
    this.shippingZipError.textContent = '';
    this.shippingZipError.hidden = true;
  }

  /** 标准化用户输入的邮编（取前 5 位数字） */
  normalizeZip(zip) {
    const digits = String(zip).trim().replace(/\D/g, '');
    return digits.slice(0, 5);
  }

  /** 校验邮编是否在白名单内 */
  isZipInList(zip, zipList) {
    const normalized = this.normalizeZip(zip);
    if (!normalized) return false;
    return zipList.some((item) => this.normalizeZip(item) === normalized);
  }

});
